import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable no-shadow */


import * as React from "react";
import { css, ThemeContext } from "@emotion/core";
import tinycolor from "tinycolor2";
import { Circle, Square, CheckCircle, CheckSquare } from "react-feather";
import { width } from "styled-system";
import { emRhythm, switchOn, rem, ellipsis, hiddenOffScreen } from "../css";
import Text from "../Text";
var _ref = {
  name: "6su6fj",
  styles: "flex-shrink:0;"
};

var SelectableItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectableItem, _React$Component);

  function SelectableItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false
    });

    return _this;
  }

  var _proto = SelectableItem.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        id = _this$props.id,
        selected = _this$props.selected,
        type = _this$props.type,
        name = _this$props.name,
        onChange = _this$props.onChange,
        item = _this$props.item,
        toLabel = _this$props.toLabel,
        toValue = _this$props.toValue,
        width = _this$props.width,
        size = _this$props.size;
    var Icon;

    if (type === "checkbox") {
      Icon = selected ? CheckSquare : Square;
    } else {
      Icon = selected ? CheckCircle : Circle;
    }

    return ___EmotionJSX(ThemeContext.Consumer, null, function (theme) {
      var fontColor = selected ? theme.colors.blue : theme.colors.text;
      return ___EmotionJSX(Label, {
        focused: _this2.state.focused,
        selected: selected,
        width: width,
        size: size,
        id: id
      }, ___EmotionJSX(Icon, {
        size: "0.8em",
        color: fontColor,
        css: _ref
      }), ___EmotionJSX(Text, {
        color: fontColor,
        ml: selected ? "sm" : "xs",
        css: /*#__PURE__*/css("transition:margin 300ms;flex:1;", ellipsis, ";")
      }, toLabel(item)), ___EmotionJSX("input", {
        css: hiddenOffScreen,
        onChange: onChange && function (event) {
          return onChange(item, event);
        },
        onFocus: function onFocus() {
          return _this2.setState({
            focused: true
          });
        },
        onBlur: function onBlur() {
          return _this2.setState({
            focused: false
          });
        },
        type: type,
        checked: selected,
        id: id + "-input",
        name: name,
        value: toValue(item)
      }));
    });
  };

  return SelectableItem;
}(React.Component);

_defineProperty(SelectableItem, "defaultProps", {
  selected: false,
  type: "checkbox",
  width: "100%",
  size: "md"
});

export { SelectableItem as default };

var Label = _styled("label", {
  target: "e1m1f26c0"
})("display:flex;align-items:center;border:1px solid ", function (p) {
  return p.selected || p.focused ? p.theme.colors.blue : p.theme.colors.border;
}, ";background-color:", function (p) {
  return p.selected ? tinycolor(p.theme.colors.blue).lighten(50).toString() : "white";
}, ";border-radius:", function (p) {
  return p.theme.radii.lg;
}, ";padding:", emRhythm(0.25), " ", emRhythm(0.5), ";cursor:pointer;font-size:", function (p) {
  return switchOn(p.size, {
    sm: rem(13),
    md: rem(16)
  }, rem(16));
}, ";&:hover{border:1px solid ", function (p) {
  return p.selected || p.focused ? tinycolor(p.theme.colors.blue).lighten(10).toString() : tinycolor(p.theme.colors.border).darken(15).toString();
}, ";background-color:", function (p) {
  return p.selected ? tinycolor(p.theme.colors.blue).lighten(52).toString() : "white";
}, ";}", width);